import { Fragment } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { ReactComponent as StepDone } from "../../../../assets/images/svg/twoPartyContract/step-done.svg";
import { ReactComponent as StepActive } from "../../../../assets/images/svg/twoPartyContract/step-active.svg";
import { ReactComponent as StepInactive } from "../../../../assets/images/svg/twoPartyContract/step-inactive.svg";
import { ReactComponent as StepDivider } from "../../../../assets/images/svg/twoPartyContract/step-divider.svg";
import styles from "../styles.module.scss";

const STEPS = [
  "lbl_transaction_data",
  "lbl_parties",
  "lbl_value_and_fees",
] as const;

interface IStepperProps {
  /** 0-based index of the step being filled. */
  currentStep: number;
  editMode?: boolean;
}

/** "Transaction data — Parties — Value and fees", with the design's step icons. */
const Stepper = ({ currentStep, editMode }: IStepperProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.stepperBlock}>
      <h2 className={styles.pageTitle}>
        {editMode ? t("lbl_edit_transaction") : t("lbl_transaction_details")}
      </h2>
      <ol className={styles.steps}>
        {STEPS.map((label, index) => (
          <Fragment key={label}>
            {index > 0 && (
              <li aria-hidden className={styles.stepDivider}>
                <StepDivider />
              </li>
            )}
            <li
              className={classNames(styles.step, {
                [styles.stepUpcoming]: index > currentStep,
              })}
              aria-current={index === currentStep ? "step" : undefined}>
              {index < currentStep ? (
                <StepDone />
              ) : index === currentStep ? (
                <StepActive />
              ) : (
                <StepInactive />
              )}
              <span>{t(label)}</span>
            </li>
          </Fragment>
        ))}
      </ol>
    </div>
  );
};

export default Stepper;
